import React, { useEffect } from "react";

// React 19 hoists these tags into <head> automatically.
export function Seo({ title, description, canonical, image, type = "website", noindex = false, jsonLd }) {
  const fullTitle = title ? `${title} — Goldman Fischer` : "Goldman Fischer — Strategic Planning, Consultants & Advisors";
  const desc =
    description ||
    "Strategic planning, consulting and advisory support to help businesses evaluate challenges, establish priorities and move forward with a practical plan.";
  const url = canonical || (typeof window !== "undefined" ? window.location.href : "");

  useEffect(() => {
    document.title = fullTitle;
  }, [fullTitle]);

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {noindex ? <meta name="robots" content="noindex,nofollow" /> : <meta name="robots" content="index,follow" />}
      {url && <link rel="canonical" href={url} />}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:type" content={type} />
      {url && <meta property="og:url" content={url} />}
      {image && <meta property="og:image" content={image} />}
      <meta name="twitter:card" content={image ? "summary_large_image" : "summary"} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      {jsonLd && (
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
      )}
    </>
  );
}
